import type { ErrorLike } from "@apollo/client";
import { ErrorCode } from "@shuttlerock/api-types/federated";
import { AccessDeniedError, NotFoundError } from "@shuttlerock/shell-components";
import { useEffect } from "react";
import { extractErrorCodes } from "../util/mapApolloErrors";

const castApolloError = (error: ErrorLike) => {
  const errorCodes = extractErrorCodes(error);

  if (errorCodes.includes(ErrorCode.Unauthorised) || errorCodes.includes(ErrorCode.NotAuthorised)) {
    return new AccessDeniedError();
  }

  if (errorCodes.includes(ErrorCode.NotFound)) {
    return new NotFoundError();
  }

  return error;
};

const useHandleApolloError = (error?: ErrorLike) => {
  useEffect(() => {
    if (!error) return;

    throw castApolloError(error);
  }, [error]);
};

export { useHandleApolloError };
